(function () {
  function findForm(root) {
    var formId = root.getAttribute("data-bundle-tier-form-id");
    if (formId) {
      var byId = document.getElementById(formId);
      if (byId && byId.tagName && byId.tagName.toLowerCase() === "form") {
        return byId;
      }
    }

    var section = root.closest(".shopify-section") || document;

    return (
      section.querySelector('product-form form[action^="/cart/add"]') ||
      section.querySelector('form[action^="/cart/add"]')
    );
  }

  function ensureQtyInput(form) {
    var qtyInput = form.querySelector('input[name="quantity"]');

    if (!qtyInput) {
      qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = "quantity";
      qtyInput.value = "1";
      form.appendChild(qtyInput);
    }

    return qtyInput;
  }

  function getSelectedQty(root) {
    var checked = root.querySelector("[data-bundle-tier-radio]:checked");
    if (checked) {
      var v = parseInt(checked.value, 10);
      if (v && v > 0) return v;
    }

    var def = parseInt(root.getAttribute("data-bundle-tier-default-qty"), 10);
    if (def && def > 0) return def;

    return 1;
  }

  function setSelectedQty(root, qty) {
    var radio = root.querySelector(
      '[data-bundle-tier-radio][value="' + String(qty) + '"]'
    );
    if (!radio) return;

    radio.checked = true;
    radio.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function portalModalToBody(root) {
    var uid = root.getAttribute("data-bundle-tier-uid") || "";
    var upsell = root.querySelector("[data-bundle-upsell]");

    if (!upsell) return null;

    if (uid) {
      var existing = document.querySelector(
        '.bundle-upsell[data-bundle-upsell-uid="' + uid + '"]'
      );
      if (existing) return existing;

      upsell.setAttribute("data-bundle-upsell-uid", uid);
    }

    document.body.appendChild(upsell);
    return upsell;
  }

  function initBundleTier(root) {
    if (!root || root.__bundleTierInit) return;
    root.__bundleTierInit = true;

    var form = findForm(root);
    if (!form) return;

    var qtyInput = ensureQtyInput(form);
    var upsell = portalModalToBody(root);
    var bypassNextSubmit = false;

    function applyQty(qty) {
      qtyInput.value = String(qty);
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function openUpsell() {
      if (!upsell) return;
      upsell.setAttribute("aria-hidden", "false");
      upsell.classList.add("is-open");
      document.body.classList.add("bundle-upsell-open");

      var primary = upsell.querySelector(
        '[data-bundle-upsell-upgrade][data-upgrade-qty="2"]'
      );
      if (primary) primary.focus();
    }

    function closeUpsell() {
      if (!upsell) return;
      upsell.setAttribute("aria-hidden", "true");
      upsell.classList.remove("is-open");
      document.body.classList.remove("bundle-upsell-open");
    }

    // Apply default qty immediately
    applyQty(getSelectedQty(root));

    // Keep qty input in sync when tier changes
    root.querySelectorAll("[data-bundle-tier-radio]").forEach(function (radio) {
      radio.addEventListener("change", function () {
        if (!radio.checked) return;
        var qty = parseInt(radio.value, 10);
        if (!qty || qty < 1) return;
        applyQty(qty);
      });
    });

    // Popup shows ONLY on ATC when qty=1
    form.addEventListener(
      "submit",
      function (e) {
        var qty = getSelectedQty(root);
        applyQty(qty);

        if (bypassNextSubmit) {
          bypassNextSubmit = false;
          return true;
        }

        if (qty === 1 && upsell) {
          e.preventDefault();
          e.stopPropagation();
          openUpsell();
          return false;
        }

        return true;
      },
      true
    );

    if (!upsell) return;

    // Close actions (backdrop + X)
    upsell
      .querySelectorAll("[data-bundle-upsell-close]")
      .forEach(function (el) {
        el.addEventListener("click", closeUpsell);
      });

    // Escape closes
    document.addEventListener("keydown", function (ev) {
      if (!upsell.classList.contains("is-open")) return;
      if (ev.key !== "Escape") return;
      closeUpsell();
    });

    // Decline => submit with 1x (bypass interception once)
    var decline = upsell.querySelector("[data-bundle-upsell-decline]");
    if (decline) {
      decline.addEventListener("click", function () {
        closeUpsell();
        setSelectedQty(root, 1);
        applyQty(1);

        bypassNextSubmit = true;

        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }

    // Upgrade => set qty then submit
    upsell
      .querySelectorAll("[data-bundle-upsell-upgrade]")
      .forEach(function (btn) {
        btn.addEventListener("click", function () {
          var upgradeQty = parseInt(btn.getAttribute("data-upgrade-qty"), 10);
          if (!upgradeQty || upgradeQty < 2) return;

          closeUpsell();
          setSelectedQty(root, upgradeQty);
          applyQty(upgradeQty);

          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      });
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll("[data-bundle-tier]")
      .forEach(function (root) {
        initBundleTier(root);
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });
})();